// xls — unduh tabel sebagai Excel (.xls via HTML), dipakai lintas-laporan.
// Pola v0.18 downloadXLS: HTML table + mime ms-excel; kolom teks pakai mso-number-format @.
import { passExportGuard } from './export-guard';

export async function downloadXLS(filename: string, inner: string): Promise<boolean> {
  if (!(await passExportGuard(filename))) return false; // guard export (anti-pencurian DB)
  const html = '<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"><style>'
    + 'table{border-collapse:collapse}th,td{border:1px solid #999;padding:4px 8px;font-size:12px;mso-number-format:"\\@"}'
    + 'th{background:#0A2A4A;color:#fff;text-align:left}h2{color:#0A2A4A;margin:0}.r{text-align:right}</style></head><body>'
    + inner + '</body></html>';
  const blob = new Blob(['﻿' + html], { type: 'application/vnd.ms-excel;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 0);
  return true;
}
